module.exports = new __parcel__URL__("jpd-list-blank.aa31352a.svg").toString();